module.exports = __webpack_public_path__ + "static/media/arrow.96c829f0.svg";